import { __rest } from "tslib";
import * as React from 'react';
import CheckIcon from "@patternfly/react-icons/dist/esm/icons/check-icon";
import { Button } from '@patternfly/react-core';
export const ConfirmButton = (_a) => {
    var { variant = 'primary' } = _a, props = __rest(_a, ["variant"]);
    return (React.createElement(Button, Object.assign({ variant: variant }, props),
        React.createElement(CheckIcon, null)));
};
ConfirmButton.displayName = 'ConfirmButton';
//# sourceMappingURL=ConfirmButton.js.map